import { CONFIG } from '../config';
import { HEIRLOOMS } from '../content/pawn';
import { ITEM_IDS, type CharacterLook, type GameState, type Inventory } from './types';

export const SAVE_VERSION = 1;

export const DEFAULT_LOOK: CharacterLook = {
  body: 'man',
  skin: '#eab08c',
  hair: 'mullet',
  hairColor: '#7a4b26',
  beard: 'stache',
  top: 'tank',
  topColor: '#f3efe4',
  bottom: 'jorts',
  bottomColor: '#5f86b8',
  shoes: 'crocs',
  shoeColor: '#7ed957',
  hat: 'trucker',
  hatColor: '#c0392b',
  belly: 0.35,
  height: 1,
  shades: false,
};

export function emptyInventory(): Inventory {
  const inv = {} as Inventory;
  for (const id of ITEM_IDS) inv[id] = 0;
  return inv;
}

export function createInitialState(opts: { name: string; look: CharacterLook; seed: number }): GameState {
  const inv = emptyInventory();
  inv.beer = 6;
  inv.hotdog = 2;
  inv.scratcher = 1;
  return {
    version: SAVE_VERSION,
    seed: opts.seed,
    player: { name: opts.name, look: { ...opts.look } },
    money: CONFIG.startMoney,
    debt: 0,
    clout: 0,
    stats: { health: 100, hunger: 80, energy: 90, buzz: 0 },
    inv,
    time: { day: 1, minutes: CONFIG.wakeMinutes },
    rent: { paidThroughWeek: 0, strikes: 0 },
    decor: [],
    interior: { items: [], stored: [], walls: 'paneling', floor: 'shag' },
    fund: 0,
    rides: [],
    ride: 'camaro',
    lotto: { week: 1, tickets: [] },
    heirlooms: HEIRLOOMS.map((h) => h.id),
    camaro: 0,
    achievements: [],
    counters: {},
    flags: {},
    feed: [],
    nextPostId: 1,
    job: null,
    status: 'playing',
  };
}
